import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction<{ email: string }>('auth/REQUEST_FORGOT_PASSWORD'));
